import React, { useState, useEffect } from 'react';
import logoNO from '../../assets/logoNO.png';
import logoPain from '../../assets/logoPain.png';
import kunais from '../../assets/kunais.png';

import './navbar.css';

const Navbar = () => {
  const [showHeader, setShowHeader] = useState();

  useEffect(() => {
    document.addEventListener('wheel', (e) => {
      if (e.deltaY < 100) {
        setShowHeader(true);
      } else {
        setShowHeader(false);
      }
    });
  });

  return (
    <div className={`header-main ${showHeader && 'header-main-scroll'}`}>
      <div className="navbarContainer">
        <a href="https://youtube.com/@painpaths" className="logoPainContainer">
          <img src={logoPain} alt="LogoPain" className="logoPain" />
        </a>
        <img src={kunais} alt="LogoKunais" className="logoKunais" />

        <h1 className="navbarTitle">Pain &nbsp; Paths</h1>
        <img src={logoNO} alt="Logo" className="logoNO" />
      </div>
    </div>
  );
};

export default Navbar;
